"use client";

import {
  HeartDynamic as ReactHeartDynamic,
  Heart as ReactHeart,
  HeartSolid as ReactHeartSolid,
} from "./deprecated/Heart";

export const HeartDynamic = ReactHeartDynamic;
export const Heart = ReactHeart;
export const HeartSolid = ReactHeartSolid;
